var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from '../Flex';
import { useChocoModalContext } from './context';
const modalContentAreaStyles = {
    flex: 1,
    overflow: 'auto',
    flexDirection: 'column',
    mx: '-32px',
    px: '32px',
};
const modalContentAreaSizeStyles = {
    large: { py: 'l' },
    small: { pb: 'm' },
};
const ChocoModalContentArea = (_a) => {
    var { children, sx } = _a, props = __rest(_a, ["children", "sx"]);
    const { size } = useChocoModalContext();
    return (_jsx(Flex, Object.assign({ sx: Object.assign(Object.assign(Object.assign({}, sx), modalContentAreaStyles), modalContentAreaSizeStyles[size]) }, props, { children: children })));
};
export default ChocoModalContentArea;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hvY29Nb2RhbENvbnRlbnRBcmVhLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvY29tbW9ucy9DaG9jb01vZGFsL0Nob2NvTW9kYWxDb250ZW50QXJlYS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBR0EsT0FBTyxFQUFFLElBQUksRUFBYSxNQUFNLFNBQVMsQ0FBQztBQUUxQyxPQUFPLEVBQUUsb0JBQW9CLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFHakQsTUFBTSxzQkFBc0IsR0FBdUI7SUFDakQsSUFBSSxFQUFFLENBQUM7SUFDUCxRQUFRLEVBQUUsTUFBTTtJQUNoQixhQUFhLEVBQUUsUUFBUTtJQUN2QixFQUFFLEVBQUUsT0FBTztJQUNYLEVBQUUsRUFBRSxNQUFNO0NBQ1gsQ0FBQztBQUVGLE1BQU0sMEJBQTBCLEdBQStDO0lBQzdFLEtBQUssRUFBRSxFQUFFLEVBQUUsRUFBRSxHQUFHLEVBQUU7SUFDbEIsS0FBSyxFQUFFLEVBQUUsRUFBRSxFQUFFLEdBQUcsRUFBRTtDQUNuQixDQUFDO0FBRUYsTUFBTSxxQkFBcUIsR0FBa0IsQ0FBQyxFQUEwQixFQUFFLEVBQUU7UUFBOUIsRUFBRSxRQUFRLEVBQUUsRUFBRSxPQUFZLEVBQVAsS0FBSyxjQUF4QixrQkFBMEIsQ0FBRjtJQUNwRSxNQUFNLEVBQUUsSUFBSSxFQUFFLEdBQUcsb0JBQW9CLEVBQUUsQ0FBQztJQUV4QyxPQUFPLENBQ0wsS0FBQyxJQUFJLGtCQUNILEVBQUUsZ0RBQ0csRUFBRSxHQUNGLHNCQUFzQixHQUN0QiwwQkFBMEIsQ0FBQyxJQUFJLENBQUMsS0FFakMsS0FBSyxjQUVSLFFBQVEsSUFDSixDQUNSLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixlQUFlLHFCQUFxQixDQUFDIn0=